import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import Index from "./pages/Index";
import Admin from "./pages/Admin";
import Auth from "./pages/Auth";
import ProductsList from "./pages/admin/ProductsList";
import ProductsNew from "./pages/admin/ProductsNew";
import ProductsImport from "./pages/admin/ProductsImport";
import PriceCategories from "./pages/admin/settings/PriceCategories";
import Locations from "./pages/admin/settings/Locations";
import MaterialTypes from "./pages/admin/settings/MaterialTypes";
import SystemSettings from "./pages/admin/settings/SystemSettings";
import AdminUsers from "./pages/admin/settings/AdminUsers";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <div className="relative min-h-screen">
          <main>
            <Routes>
              {/* Rotas públicas */}
              <Route path="/" element={<Index />} />
              <Route path="/auth" element={<Auth />} />
              
              {/* Rotas protegidas */}
              <Route element={<ProtectedRoute />}>
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin/products/list" element={<ProductsList />} />
                <Route path="/admin/products/new" element={<ProductsNew />} />
                <Route path="/admin/products/import" element={<ProductsImport />} />
                <Route path="/admin/settings/price-categories" element={<PriceCategories />} />
                <Route path="/admin/settings/locations" element={<Locations />} />
                <Route path="/admin/settings/material-types" element={<MaterialTypes />} />
                <Route path="/admin/settings/system" element={<SystemSettings />} />
                <Route path="/admin/settings/users" element={<AdminUsers />} />
              </Route>
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
